import {
  usersAPI,
  usergroupAPI
} from '@/api';

import { ErrorService } from '@/services/error-service.js';


/**************** STATE *******************/
const state = {
  usersDemandesCount: 0,
  usergroupsDemandesCount: 0,
  attachementsDemandesCount: 0,
  usersDemandesList: [],
  usergroupsDemandesList: [],
  attachementsDemandesList: [],
  demandesError: null,
  currentUsersDemandesFilters: {
    status__in: ['1']
  },
  currentUsergroupsDemandesFilters: {
    status__in: ['1']
  }
};

/**************** GETTERS *****************/
const getters = {
};

/*************** MUTATIONS ****************/
const mutations = {
  SET_DEMANDES_USERS_LIST: (state, payload) => {
    if (payload && payload.results) {
      state.usersDemandesList = payload.results;
    }
    if (payload && payload.count) {
      state.usersDemandesCount = payload.count;
    }
  },

  SET_DEMANDES_USERGROUPS_LIST: (state, payload) => {
    if (payload && payload.results) {
      state.usergroupsDemandesList = payload.results;
    }
    if (payload && payload.count) {
      state.usergroupsDemandesCount = payload.count;
    }
  },

  SET_USERGROUPS_ATTACHEMENTS_LIST: (state, payload) => {
    if (payload && payload.results) {
      state.attachementsDemandesList = payload.results;
    }
    if (payload && payload.count) {
      state.attachementsDemandesCount = payload.count;
    }
  },

  SET_ERROR: (state, error) => {
    if (error) {
      ErrorService.onError(error);
      state.demandesError = error.response.data.detail;
    } else {
      state.demandesError = error;
    }
  },

  SET_USERS_DEMANDES_FILTERS: (state, payload) => {
    if (state.currentUsersDemandesFilters[payload.filter].findIndex(el => el === payload.value) === -1) {
      state.currentUsersDemandesFilters[payload.filter].push(payload.value);
    }
  },

  SET_USERGROUPS_DEMANDES_FILTERS: (state, payload) => {
    if (state.currentUsergroupsDemandesFilters[payload.filter].findIndex(el => el === payload.value) === -1) {
      state.currentUsergroupsDemandesFilters[payload.filter].push(payload.value);
    }
  },

  REMOVE_USERS_DEMANDES_FILTERS: (state, payload) => {
    const index = state.currentUsersDemandesFilters[payload.filter].findIndex(el => el === payload.value);
    if (index !== -1) {
      state.currentUsersDemandesFilters[payload.filter].splice(index, 1);
    }
  },

  REMOVE_USERGROUPS_DEMANDES_FILTERS: (state, payload) => {
    const index = state.currentUsergroupsDemandesFilters[payload.filter].findIndex(el => el === payload.value);
    if (index !== -1) {
      state.currentUsergroupsDemandesFilters[payload.filter].splice(index, 1);
    }
  }
};
/**************** ACTIONS *****************/
const actions = {
  GET_USERS_DEMANDES_LIST: async ({ state, commit }, { direction, field }) => {
    const filters = state.currentUsersDemandesFilters;
    if (field) {
      await usersAPI.orderUsersList(direction, field, filters)
        .then((users) => {
          if (users) {
            commit('SET_ERROR', null);
            commit('SET_DEMANDES_USERS_LIST', users);
          }
        })
        .catch((error) => {
          commit('SET_ERROR', error);
        });
    } else {
      await usersAPI.getUsersList(filters)
        .then((users) => {
          if (users) {
            commit('SET_ERROR', null);
            commit('SET_DEMANDES_USERS_LIST', users);
          }
        })
        .catch((error) => {
          commit('SET_ERROR', error);
        });
    }
  },

  GET_USERGROUPS_DEMANDES_LIST: async ({ state, commit }, { direction, field }) => {
    const filters = state.currentUsergroupsDemandesFilters;
    if (field) {
      await usergroupAPI.orderUsergroupsList(direction, field, [], filters)
        .then((usergroups) => {
          if (usergroups) {
            commit('SET_ERROR', null);
            commit('SET_DEMANDES_USERGROUPS_LIST', usergroups);
          }
        })
        .catch((error) => {
          commit('SET_ERROR', error);
        });
    } else {
      await usergroupAPI.getUsergroupsList([], filters)
        .then((usergroups) => {
          if (usergroups) {
            commit('SET_ERROR', null);
            commit('SET_DEMANDES_USERGROUPS_LIST', usergroups);
          }
        })
        .catch((error) => {
          commit('SET_ERROR', error);
        });
    }
  },

  GET_ATTACHMENT_DEMANDES_LIST: async ({ commit }) => {
    const attachments = await usergroupAPI.getUsergroupAttachments();
    if (attachments) {
      commit('SET_ERROR', null);
      commit('SET_USERGROUPS_ATTACHEMENTS_LIST', attachments);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
